import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "space-y-4 p-4 sm:px-6 sm:pt-6 lg:px-8 lg:pt-8 xl:pt-0" }
const _hoisted_2 = { class: "flex space-x-16" }
const _hoisted_3 = { class: "flex flex-1 flex-col space-y-4" }
const _hoisted_4 = { class: "my-4 text-2xl font-bold text-gray-800 xl:my-8 xl:text-3xl" }
const _hoisted_5 = { class: "xl:text-md flex-1 font-medium text-gray-500" }
const _hoisted_6 = { class: "text-primary" }
const _hoisted_7 = { class: "flex items-center text-xl font-semibold text-gray-700 xl:text-2xl" }
const _hoisted_8 = ["alt"]
const _hoisted_9 = { class: "grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3" }

import { computed, ComputedRef } from 'vue';
import { ChartBarIcon, CurrencyDollarIcon, PhoneIcon, ReplyIcon } from '@heroicons/vue/solid';
import { Permission, DashboardItem, UserModel } from '@/types';
import { useAuthStore } from '@/stores';
import SVGWhatsApp from '@/components/svg/SVGWhatsApp.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

const authStore = useAuthStore();
const user: ComputedRef<UserModel | undefined> = computed(() => authStore.userModel);

const baseLinks: DashboardItem[] = [
    {
        title: 'dashboard.calls',
        description: 'call.description',
        permission: Permission.VIEW_CALLS,
        routeName: 'CallList',
        icon: PhoneIcon,
    },
    {
        title: 'report.call.title',
        description: 'report.call.description',
        permission: Permission.VIEW_CALL_REPORT,
        routeName: 'CallReport',
        icon: ChartBarIcon,
    },
    {
        title: 'report.contactCenterPerDay.title',
        description: 'report.contactCenterPerDay.description',
        permission: Permission.VIEW_CONTACT_CENTER_PER_DAY_REPORT,
        routeName: 'ContactCenterPerDayReport',
        icon: ChartBarIcon,
    },
    {
        title: 'report.contactCenterPerAgent.title',
        description: 'report.contactCenterPerAgent.description',
        permission: Permission.VIEW_CONTACT_CENTER_PER_AGENT_REPORT,
        routeName: 'ContactCenterPerAgentReport',
        icon: ChartBarIcon,
    },
    {
        title: 'report.agentProductivityPerDay.title',
        description: 'report.agentProductivityPerDay.description',
        permission: Permission.VIEW_AGENT_PRODUCTIVITY_PER_DAY_REPORT,
        routeName: 'AgentProductivityPerDayReport',
        icon: ChartBarIcon,
    },
    {
        title: 'report.agentProductivityPerAgent.title',
        description: 'report.agentProductivityPerAgent.description',
        permission: Permission.VIEW_AGENT_PRODUCTIVITY_PER_AGENT_REPORT,
        routeName: 'AgentProductivityPerAgentReport',
        icon: ChartBarIcon,
    },
    {
        title: 'report.realtime.title',
        description: 'report.realtime.description',
        permission: Permission.VIEW_REALTIME_REPORT,
        routeName: 'RealtimeReport',
        icon: ChartBarIcon,
    },
    {
        title: 'report.realtimeAgentExtension.title',
        description: 'report.realtimeAgentExtension.description',
        permission: Permission.VIEW_REALTIME_AGENT_EXTENSION_REPORT,
        routeName: 'RealtimeAgentExtensionReport',
        icon: ChartBarIcon,
    },
    {
        title: 'report.agentDeviceStatusHistory.title',
        description: 'report.agentDeviceStatusHistory.description',
        permission: Permission.VIEW_AGENT_DEVICE_STATUS_HISTORY_REPORT,
        routeName: 'AgentDeviceStatusHistoryReport',
        icon: ChartBarIcon,
    },
    {
        title: 'report.billing.title',
        description: 'report.billing.description',
        permission: Permission.VIEW_BILLING_REPORT,
        routeName: 'BillingReportPage',
        icon: CurrencyDollarIcon,
    },
];

const whatsAppLink: DashboardItem = {
    title: 'dashboard.whatsapp.title',
    description: 'dashboard.whatsapp.description',
    permission: Permission.VIEW_INTEGRATIONS,
    routeName: 'ListWhatsAppMeta',
    icon: SVGWhatsApp,
};

const links = computed(() =>
    user.value?.hasWhatsAppMeta ? [whatsAppLink, ...baseLinks] : baseLinks,
);

return (_ctx: any,_cache: any) => {
  const _component_UiDashboardLink = _resolveComponent("UiDashboardLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t('welcomeLogged')) + ", " + _toDisplayString(user.value?.name) + ". ", 1),
        _createElementVNode("p", _hoisted_5, [
          _createTextVNode(_toDisplayString(_ctx.$t('dashboard.welcome')) + " ", 1),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('dashboard.welcomeAct')), 1)
        ]),
        _createElementVNode("h2", _hoisted_7, [
          _createVNode(_unref(ReplyIcon), {
            class: "text-secondary mr-1 h-8 w-8 rotate-180",
            "aria-hidden": "true"
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('dashboard.gettingStarted')), 1)
        ])
      ]),
      _createElementVNode("img", {
        src: "/img/image-home-verde.png",
        class: "hidden h-[300px] xl:block",
        alt: _ctx.$t('welcomeLogged')
      }, null, 8, _hoisted_8)
    ]),
    _createElementVNode("div", _hoisted_9, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(links.value, (link, index) => {
        return (_openBlock(), _createBlock(_component_UiDashboardLink, {
          key: `dashboard-link-${index}`,
          routeName: link.routeName,
          permission: link.permission,
          title: link.title,
          description: link.description,
          icon: link.icon
        }, null, 8, ["routeName", "permission", "title", "description", "icon"]))
      }), 128))
    ])
  ]))
}
}

})